// extracted by mini-css-extract-plugin
var _1 = "EditCard-module__animateUploadProgressBarWidth--bHiK5";
var _2 = "EditCard-module__animatedBackground--_XVeG";
var _3 = "EditCard-module__buttons--JRnzo";
var _4 = "EditCard-module__cancelButton--KSuwI";
var _5 = "EditCard-module__details--gI1cn";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttons", _4 as "cancelButton", _5 as "details" }
